const booleanValues: Record<string, string> = {
  viteAppDEV: import.meta.env.VITE_APP_DEV || 'REPLACE_VITE_APP_DEV',
};

const getBoolean = (v: string) => booleanValues[v] === 'true';

export const VITE_APP_API_URL = import.meta.env.VITE_APP_API_URL || 'REPLACE_VITE_APP_API_URL';
export const VITE_APP_ENV = import.meta.env.VITE_APP_ENV || 'REPLACE_VITE_APP_ENV';
export const VITE_APP_LABEL_URL = import.meta.env.VITE_APP_LABEL_URL || 'REPLACE_VITE_APP_LABEL_URL';

export const VITE_APP_SORT_CENTER_API_URL =
  import.meta.env.VITE_APP_SORT_CENTER_API_URL || 'REPLACE_VITE_APP_SORT_CENTER_API_URL';

// Облачная печать (CloudPrinter.Gateway) — отдельный сервис cloud-printer-api.
// Не задан (остался шаблон `REPLACE_…`) — виджет принтера на бэк не ходит, печать локальная.
export const VITE_APP_CLOUD_PRINTER_API_URL =
  import.meta.env.VITE_APP_CLOUD_PRINTER_API_URL || 'REPLACE_VITE_APP_CLOUD_PRINTER_API_URL';

export const VITE_APP_DEV = getBoolean('viteAppDEV');

export const VITE_APP_KEYCLOAK_URL = import.meta.env.VITE_APP_KEYCLOAK_URL || 'REPLACE_VITE_APP_KEYCLOAK_URL';
export const VITE_APP_KEYCLOAK_REALM = import.meta.env.VITE_APP_KEYCLOAK_REALM || 'REPLACE_VITE_APP_KEYCLOAK_REALM';
export const VITE_APP_KEYCLOAK_CLIENT_ID =
  import.meta.env.VITE_APP_KEYCLOAK_CLIENT_ID || 'REPLACE_VITE_APP_KEYCLOAK_CLIENT_ID';
export const VITE_APP_KEYCLOAK_SCOPE = import.meta.env.VITE_APP_KEYCLOAK_SCOPE || 'REPLACE_VITE_APP_KEYCLOAK_SCOPE';
